import Stocks from './stocks/Stocks';
import StockBox from './stockBox/StockBox';

export {
    Stocks,
    StockBox,
};



// WEBPACK FOOTER //
// ./src/components/inventory/index.js